import enTranslationMessages from './translations/en.json';
import esTranslationMessages from './translations/es.json';

// Pollyfills for IE11 & Safari 12-
// https://github.com/formatjs/react-intl/blob/master/docs/Upgrade-Guide.md#migrate-to-using-native-intl-apis

/* istanbul ignore if */
if (!Intl.getCanonicalLocales) {
  require('@formatjs/intl-getcanonicallocales/polyfill');
}
/* istanbul ignore if */
if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/locale-data/en'); // Add locale data for en
  require('@formatjs/intl-pluralrules/locale-data/es'); // Add locale data for es
}
/* istanbul ignore if */
if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/locale-data/en'); // Add locale data for en
  require('@formatjs/intl-relativetimeformat/locale-data/es'); // Add locale data for es
}

export const appLocales = ['en', 'es'];

export const translationMessages = {
  en: enTranslationMessages,
  es: esTranslationMessages,
};
